import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-circle-user-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.1699 20C18.1699 18.4087 17.5378 16.8826 16.4126 15.7574C15.2873 14.6321 13.7612 14 12.1699 14C10.5786 14 9.0525 14.6321 7.92728 15.7574C6.80206 16.8826 6.16992 18.4087 6.16992 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.1699 14C14.3791 14 16.1699 12.2091 16.1699 10C16.1699 7.79086 14.3791 6 12.1699 6C9.96078 6 8.16992 7.79086 8.16992 10C8.16992 12.2091 9.96078 14 12.1699 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.1699 22C17.6928 22 22.1699 17.5228 22.1699 12C22.1699 6.47715 17.6928 2 12.1699 2C6.64707 2 2.16992 6.47715 2.16992 12C2.16992 17.5228 6.64707 22 12.1699 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`
})
export class CircleUserIconComponent {

}
